import React, { useState, useRef, useEffect } from 'react';
import { DateRange } from 'react-date-range';
import { addDays, format, set } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Form } from 'react-bootstrap';
import './customDateRangePicker.css';

const DateRangeInput = ({ name, onChange, customPlaceHolder }) => {
    const [showPicker, setShowPicker] = useState(false);
    const [range, setRange] = useState({
        startDate: null,
        endDate: null,
        key: 'selection',
    });

    const ref = useRef(null);

    const handleSelect = (ranges) => {
        const selected = ranges.selection;
        setRange(selected);

        if (
            selected.startDate &&
            selected.endDate &&
            selected.startDate.getTime() !== selected.endDate.getTime()
        ) {
            setShowPicker(false);
        }

        onChange && onChange({ name, range: selected });
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setShowPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const formattedValue =
        range.startDate && range.endDate
            ? `${format(range.startDate, 'dd/MM/yyyy')} - ${format(range.endDate, 'dd/MM/yyyy')}`
            : '';

    const clearDates = () => {
        setRange({ startDate: null, endDate: null, key: 'selection' });
        setShowPicker(false);
        onChange && onChange({ name, range: null });
    };

    return (
        <div className="date-range-input-wrapper" ref={ref} style={{ position: 'relative' }}>
            <div className="input-icon-wrapper">
                <i className="bi bi-calendar input-icon"></i>
                <Form.Control
                    type="text"
                    readOnly
                    value={!formattedValue && formattedValue !== '' ? undefined : formattedValue}
                    onClick={() => {
                        setRange({
                            startDate: range.startDate || addDays(new Date(), 1),
                            endDate: range.endDate || addDays(new Date(), 2),
                            key: 'selection',
                        });
                        setShowPicker(true)
                    }}
                    className="date-range-input element-style"
                    placeholder={customPlaceHolder || 'Select Date Range'}
                />
                {formattedValue && (
                    <i className="bi bi-x-circle clear-icon" onClick={clearDates}></i>
                )}
            </div>

            {showPicker && (
                <div className="date-picker-popover">
                    <DateRange
                        editableDateInputs={true}
                        onChange={handleSelect}
                        moveRangeOnFirstSelection={false}
                        ranges={[range]}
                        months={1}
                        direction="vertical"
                        minDate={new Date()}
                        className="custom-date-range"
                    />
                </div>
            )}
        </div>
    );
};

export default DateRangeInput;
